const metrics = [
  {
    id: 'session',
    label: 'Traffic',
    metrics: [
      {
        id: 'impression:count',
        key: 'impression:count',
        label: 'Impressions',
        format: 'number'
      },
      {
        id: 'count',
        label: 'Sessions',
        format: 'number'
      },
      // {
      //   id: 'count-uniq',
      //   label: 'Unique visits',
      //   format: 'number'
      // },
      {
        id: 'pagesPerSession',
        label: 'Pageviews / Session',
        format: 'decimal'
      },
      {
        id: 'duration',
        label: 'Avg Sessions Length',
        format: 'seconds'
      },
      // {
      //   id: 'valuePerVisit',
      //   label: 'Value / visit',
      //   format: 'currency',
      //   variants: [
      //     {
      //       id: 'valuePerVisit-nonDirectTouch',
      //       label: 'Data Driven (PV)',
      //       format: 'currency'
      //     },
      //     {
      //       id: 'valuePerVisit-nonDirectClicks',
      //       label: 'Data Driven (PC)',
      //       format: 'currency'
      //     },
      //     {
      //       id: 'valuePerVisit-nonDirectLastClick',
      //       label: 'Last Click (Non Direct)',
      //       format: 'currency'
      //     },
      //     {
      //       id: 'valuePerVisit-nonDirectLastTouch',
      //       label: 'Last Touch (Non Direct)',
      //       format: 'currency'
      //     }
      //   ]
      // },
      // {
      //   id: 'bounceRate',
      //   label: 'Bounce rate',
      //   format: 'doublePercent'
      // },
      // {
      //   id: 'checkoutAbandonmentRate',
      //   label: 'Checkout abandonment rate',
      //   format: 'doublePercent'
      // },
      // {
      //   id: 'failedDiscoveryRate',
      //   label: 'Failed discovery rate',
      //   format: 'doublePercent'
      // },
      // {
      //   id: 'conversionRate',
      //   label: 'Conversion rate (CR)',
      //   format: 'doublePercent'
      // }
    ]
  },
  {
    id: 'order',
    label: 'Conversion',
    metrics: [
      {
        id: 'count-touchpoint',
        label: 'Touchpoints Before Conversion',
        format: 'number',
        variants: [
          {
            id: 'count-rf-touchpoint',
            label: 'Touchpoints (RF)',
            format: 'number'
          },
          {
            id: 'count-ftd-touchpoint',
            label: 'Touchpoints (FTD)',
            format: 'number'
          }
        ]
      },
      {
        id: 'count-touchpoint-per-conversion',
        label: 'Touchpoints Per Conversions',
        format: 'number',
        variants: [
          {
            id: 'count-rf-touchpoint-per-conversion',
            label: 'Touchpoints Per Conversions (RF)',
            format: 'decimalDouble'
          },
          {
            id: 'count-ftd-touchpoint-per-conversion',
            label: 'Touchpoints Per Conversions (FTD)',
            format: 'decimalDouble'
          }
        ]
      },
      {
        id: 'count-session',
        label: 'Sessions Before Conversion',
        format: 'number',
        variants: [
          {
            id: 'count-rf-session',
            label: 'Sessions (RF)',
            format: 'number'
          },
          {
            id: 'count-ftd-session',
            label: 'Sessions (FTD)',
            format: 'number'
          }
        ]
      },
      {
        id: 'count-impression',
        label: 'Impressions Before Conversion',
        format: 'number',
        variants: [
          {
            id: 'count-rf-impression',
            label: 'Impressions (RF)',
            format: 'number'
          },
          {
            id: 'count-ftd-impression',
            label: 'Impressions (FTD)',
            format: 'number'
          }
        ]
      },
      {
        id: 'count-touched',
        label: 'Conversions Touched',
        format: 'number',
        variants: [
          {
            id: 'count-rf-touched',
            label: 'Conversions (RF)',
            format: 'number'
          },
          {
            id: 'count-ftd-touched',
            label: 'Conversions (FTD)',
            format: 'number'
          }
        ]
      },
      {
        id: 'attribute-count-rf',
        label: 'Conversions Attributed (RF)',
        format: 'decimalDouble',
        variants: [
          {
            id: 'regCount-non-direct-touch',
            label: 'Data Driven (PV)',
            format: 'decimalDouble'
          },
          {
            id: 'regCount-non-direct-clicks',
            label: 'Data Driven (PC)',
            format: 'number'
          },
          {
            id: 'regCount-non-direct-last-click',
            label: 'Last Click (Non Direct)',
            format: 'number'
          },
          {
            id: 'regCount-non-direct-last-touch',
            label: 'Last Touch (Non Direct)',
            format: 'number'
          }
        ]
      },
      {
        id: 'attribute-count-ftd',
        label: 'Conversions Attributed (FTD)',
        format: 'decimalDouble',
        variants: [
          {
            id: 'ftdCount-non-direct-touch',
            label: 'Data Driven (PV)',
            format: 'decimalDouble'
          },
          {
            id: 'ftdCount-non-direct-clicks',
            label: 'Data Driven (PC)',
            format: 'number'
          },
          {
            id: 'ftdCount-non-direct-last-click',
            label: 'Last Click (Non Direct)',
            format: 'number'
          },
          {
            id: 'ftdCount-non-direct-last-touch',
            label: 'Last Touch (Non Direct)',
            format: 'number'
          }
        ]
      },
      {
        id: 'conversion-impact-reg',
        label: 'Conversion Impact (RF)',
        format: 'decimalDouble',
        variants: [
          {
            id: 'regImpact-non-direct-touch',
            label: 'Data Driven (PV)',
            format: 'decimalDouble'
          },
          {
            id: 'regImpact-non-direct-clicks',
            label: 'Data Driven (PC)',
            format: 'number'
          },
          {
            id: 'regImpact-non-direct-last-click',
            label: 'Last Click (Non Direct)',
            format: 'number'
          },
          {
            id: 'regImpact-non-direct-last-touch',
            label: 'Last Touch (Non Direct)',
            format: 'number'
          }
        ]
      },
      {
        id: 'conversion-impact-ftd',
        label: 'Conversion Impact (FTD)',
        format: 'decimalDouble',
        variants: [
          {
            id: 'ftdImpact-non-direct-touch',
            label: 'Data Driven (PV)',
            format: 'decimalDouble'
          },
          {
            id: 'ftdImpact-non-direct-clicks',
            label: 'Data Driven (PC)',
            format: 'number'
          },
          {
            id: 'ftdImpact-non-direct-last-click',
            label: 'Last Click (Non Direct)',
            format: 'number'
          },
          {
            id: 'ftdImpact-non-direct-last-touch',
            label: 'Last Touch (Non Direct)',
            format: 'number'
          }
        ]
      },
      {
        id: 'total',
        label: 'Revenue',
        format: 'currency',
        variants: [
          {
            id: 'total-non-direct-touch',
            label: 'Data Driven (PV)'
          },
          {
            id: 'total-non-direct-clicks',
            label: 'Data Driven (PC)'
          },
          {
            id: 'total-non-direct-last-click',
            label: 'Last Click (Non Direct)'
          },
          {
            id: 'total-non-direct-last-touch',
            label: 'Last Touch (Non Direct)'
          }
        ]
      },
      // {
      //   id: 'count-every-session',
      //   label: 'Visits before conversion',
      //   format: 'number'
      // },
      // {
      //   id: 'aov',
      //   label: 'Avg conversion value',
      //   format: 'currency',
      //   variants: [
      //     {
      //       id: 'aov-non-direct-touch',
      //       label: 'Data Driven (PV)'
      //     },
      //     {
      //       id: 'aov-non-direct-clicks',
      //       label: 'Data Driven (PC)'
      //     },
      //     {
      //       id: 'aov-non-direct-last-click',
      //       label: 'Last Click (Non Direct)'
      //     },
      //     {
      //       id: 'aov-non-direct-last-touch',
      //       label: 'Last Touch (Non Direct)'
      //     }
      //   ]
      // }
    ]
  },
  {
    id: 'cost',
    label: 'Costs',
    metrics: [
      // {
      //   id: 'total',
      //   label: 'Marketing cost',
      //   format: 'currency'
      // },
      {
        id: 'perVisit',
        label: 'Cost / Session',
        format: 'currency'
      },
      {
        id: 'perOrder-rf',
        label: 'Cost / Conversion (RF)',
        format: 'currency',
        variants: [
          {
            id: 'perOrder-divvit-rf',
            label: 'Data Driven (PV) (RF)',
            format: 'currency'
          },
          {
            id: 'perOrder-rf',
            label: 'Data Driven (PC) (RF)',
            format: 'currency'
          },
          {
            id: 'perOrderLast-rf',
            label: 'Last Click (Non Direct) (RF)',
            format: 'currency'
          },
          {
            id: 'perOrder-non-direct-last-touch-rf',
            label: 'Last Touch (Non Direct) (RF)',
            format: 'currency'
          }
        ]
      },

      {
        id: 'perOrder-ftd',
        label: 'Cost / Conversion (FTD)',
        format: 'currency',
        variants: [
          {
            id: 'perOrder-divvit-ftd',
            label: 'Data Driven (PV) (FTD)',
            format: 'currency'
          },
          {
            id: 'perOrder-ftd',
            label: 'Data Driven (PC) (FTD)',
            format: 'currency'
          },
          {
            id: 'perOrderLast-ftd',
            label: 'Last Click (Non Direct) (FTD)',
            format: 'currency'
          },
          {
            id: 'perOrder-non-direct-last-touch-ftd',
            label: 'Last Touch (Non Direct) (FTD)',
            format: 'currency'
          }
        ]
      },



      {
        id: 'roi',
        label: 'Marketing ROI',
        format: 'doublePercent',
        variants: [
          {
            id: 'roi-divvit',
            label: 'Data Driven (PV)',
            format: 'doublePercent'
          },
          {
            id: 'roi-linear',
            label: 'Data Driven (PC)',
            format: 'doublePercent'
          },
          {
            id: 'roi',
            label: 'Last Click (Non Direct)',
            format: 'doublePercent'
          },
          {
            id: 'roi-non-direct-last-touch',
            label: 'Last Touch (Non Direct)',
            format: 'doublePercent'
          }
        ]
      },
      // {
      //   id: 'ofSales',
      //   label: 'Cost / Sales',
      //   format: 'doublePercent',
      //   variants: [
      //     {
      //       id: 'ofSales-divvit',
      //       label: 'Data Driven (PV)',
      //       format: 'doublePercent'
      //     },
      //     {
      //       id: 'ofSales-linear',
      //       label: 'Data Driven (PC)',
      //       format: 'doublePercent'
      //     },
      //     {
      //       id: 'ofSales',
      //       label: 'Last Click (Non Direct)',
      //       format: 'doublePercent'
      //     },
      //     {
      //       id: 'ofSales-non-direct-last-touch',
      //       label: 'Last Touch (Non Direct)',
      //       format: 'doublePercent'
      //     }
      //   ]
      // }
    ]
  },
  // {
  //   id: 'customer',
  //   label: 'Customers',
  //   metrics: [
  //     {
  //       id: 'cac',
  //       label: 'Customer acquisition cost (CAC)',
  //       format: 'currency',
  //       variants: [
  //         {
  //           id: 'cac-divvit',
  //           label: 'Data Driven (PV)',
  //           format: 'currency'
  //         },
  //         {
  //           id: 'cac',
  //           label: 'Data Driven (PC)',
  //           format: 'currency'
  //         },
  //         {
  //           id: 'cac-last-click',
  //           label: 'Last Click (Non Direct)',
  //           format: 'currency'
  //         },
  //         {
  //           id: 'cac-non-direct-last-touch',
  //           label: 'Last Touch (Non Direct)',
  //           format: 'currency'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'new',
  //       label: 'New customer count',
  //       format: 'number',
  //       variants: [
  //         {
  //           id: 'new-non-direct-touch',
  //           label: 'Data Driven (PV)'
  //         },
  //         {
  //           id: 'new-non-direct-clicks',
  //           label: 'Data Driven (PC)'
  //         },
  //         {
  //           id: 'new-non-direct-last-click',
  //           label: 'Last Click (Non Direct)'
  //         },
  //         {
  //           id: 'new-non-direct-last-touch',
  //           label: 'Last Touch (Non Direct)'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'new-percent',
  //       label: '% New customers',
  //       format: 'doublePercent',
  //       variants: [
  //         {
  //           id: 'new-percent-non-direct-touch',
  //           label: 'Data Driven (PV)'
  //         },
  //         {
  //           id: 'new-percent-non-direct-clicks',
  //           label: 'Data Driven (PC)'
  //         },
  //         {
  //           id: 'new-percent-non-direct-last-click',
  //           label: 'Last Click (Non Direct)'
  //         },
  //         {
  //           id: 'new-percent-non-direct-last-touch',
  //           label: 'Last Touch (Non Direct)'
  //         }
  //       ]
  //     }
  //   ]
  // }
]

export const flattenMetrics = metrics.reduce((acc, metricGroup) => {
  const metricsFromGroup = metricGroup.metrics.reduce((acc, metric) => {
    if (metric.hasOwnProperty('variants')) {
      return acc.concat(metric.variants.map(variant =>
        ({
          ...metric,
          ...variant,
          label: `${metric.label} (${variant.label})`,
          variantGroup: metric.id,
          variantLabel: variant.label,
          metricLabel: metric.label
        })
      ))
    } else {
      return acc.concat(metric)
    }
  }, [])
  return acc.concat(metricsFromGroup.map(metric => {
    return {
      ...metric,
      metricGroupId: metricGroup.id,
      metricGroupLabel: metricGroup.label,
      key: metric.key || `${metricGroup.id}:${metric.id}`
    }
  }))
}, [])

export function getMetricsByGroup(metricGroupId) {
  return flattenMetrics.filter(metric => metric.metricGroupId === metricGroupId)
}

export function getMetricByKey(metricKey) {
  return flattenMetrics.find(metric => metricKey === metric.key)
}

export default metrics



// WEBPACK FOOTER //
// ./client/utils/metrics.js